"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.EmailCanvasBlockSocialIndicator = ({ hasSocialChildren }) => {
    if (!hasSocialChildren) {
        return null;
    }
    return (react_1.default.createElement(react_2.OsmosysTooltip, { label: "This content group has social links", divProps: { className: 'text-primary small' } },
        react_1.default.createElement(react_2.OsmosysDiv, null,
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: "social", size: "sm" }))));
};
//# sourceMappingURL=BlockSocialIndicator.js.map